import React from 'react';
import { useState } from 'react';
import './modal.css'
import { Modalmail } from './modalemail/ModalEmail';

interface ModalSwalProps {
  show: boolean;

}
type ID = undefined | null | number

const ModalSwal: React.FC<ModalSwalProps> = ({ show }) => {
    const [ ID , setID]=useState<ID>(undefined)

  if (!show) return null;

  return (
    <>
    <div className='overlay' style={{zIndex:9}}></div>
    
      <div className="modal-swal" >
        
      <img src="/media/imgv2/info.svg" alt="" />
      
        <h2>Module Disabled</h2>
        <p>The module you're looking for isn't enabled, but don't worry! ​</p>
        <p> We can activate it for you quickly and easily. Just let us know, and we'll take care of it!</p>
        <br />
        <div className='col' style={{flex:1,margin:'0 10px'}}>
                <button className='btn btn-light-marino f-parrafo' onClick={ () => setID(null)}>Contact Sales</button>
            </div>
        {/*<div className='row' style={{display:'flex',justifyContent:'space-between'}}>
            <div className='col' style={{flex:1,margin:'0 10px'}}>
                <button className='btn btn-light-marino f-parrafo' onClick={ () => setID(null)}>Contact Sales</button>
            </div>
            <div className='col'  style={{flex:1,margin:'0 10px'}}>
                <a className='btn btn-light-marino f-parrafo' href='https://www.figma.com/proto/pAzrWNUGkTTsdccu7wcA8v/CloudTransit-Xchange-(New)?page-id=3602%3A1285&type=design&node-id=3602-9464&viewport=-1348%2C419%2C0.07&t=gK2ueIF01Y4beJNs-1&scaling=min-zoom' target='_blank'>More Information</a>
            </div>
  </div>*/}

      </div>
      {ID !== undefined && <Modalmail setID={setID} id={ID} />}
    </>
  );
};

export default ModalSwal;